import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { withRouter } from "../../providers/withRouter";
import { createComment, getComments } from '../../services/comment.service';
import { IoSave } from "react-icons/io5";
import Delete from "../../icons/delete.svg";
import Editar from "../../icons/editar.svg";
import { UsuarioContext } from '../../providers/userContext';
import { editarComentario, eliminarComentario, fijarComentario, formatoFechasEs } from '../../functions/funciones';
import ModalEditarComentarios from "./AllComments";
import { CircularProgress } from '@mui/material';
import ComentariosEstructura from '../comentariosEstructura';

const Comentarios = (props) => {
  const { t } = useTranslation('common');

  const user = useContext(UsuarioContext)
  const [comentario, setComentario] = useState('');
  const [recargar, setRecargar] = useState(0);
  const [comentarios, setComentarios] = useState([]);
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const finca = props.finca;

  useEffect(() => {
    const fetchComentarios = async () => {
      setIsLoading(false);
      try {
        const response = await getComments({ filtros: { prop_id: finca.id, tipo: "comment" } });
        const comentariosFiltrados = response.data.map(comment => {
          comment.usuario = comment.user?.technician?.[0] || comment.user?.consultant?.[0] || comment.user?.admin?.[0];
          return comment;
        });
        setComentarios(comentariosFiltrados);
      } catch (error) {
        console.error("Error fetching comments:", error);
      }
    };
    fetchComentarios();
  }, [finca.id, recargar]);



  function guardarComentarios() {
    try {
      let infoComentario = {
        prop_id: finca.id,
        supp_id: null,
        aaff_id: null,
        texto: comentario,
        tipo: "comment",
        status: 1,
      }
      createComment(infoComentario).then(res => {
        handleSubirDocsCallback(res)
        setComentario('')
      })
    } catch (error) {
      console.log(error)
    }

  }

  function cambiarComentarios(evt) {
    const value = evt.target.value;
    setComentario(value);
  }


  const handleSubirDocsCallback = () => {
    setRecargar(!recargar);
  };

  const editarComment = async (id, comm) => {
    editarComentario(id, user.id, comm).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
  }
  const eliminarComment = async (id) => {
    eliminarComentario(id).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
  }
  const fijarComment = async (id, fijado) => {
    fijarComentario(id, fijado).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
    console.log("Fijar comentario ID:", id, "Fijado:", fijado);
  };
  return (
    <>
      <ModalEditarComentarios
        comentarios={comentarios}
        opened={modalEditarOpened}
        eliminarComment={eliminarComment}
        editarComment={editarComment}
        fijarComment={fijarComment}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      />
      <div style={{ position: 'relative' }}>
        <p style={{ paddingBottom: 10 }}>
          <b>{t('comments.communityComments')}</b>
        </p>
        <div style={{ overflow: 'scroll', maxHeight: 200 }} className="comment-container">
          {!comentarios || isLoading ? <CircularProgress style={{ height: 20, width: 20, color: '#92004D', position: 'absolute', top: '15%', left: '5%' }} /> :
            comentarios.length === 0
              ? t('comments.noComments')
              :
              <>
                {comentarios.slice(0, 4).map(comm => {
                  return (
                    <ComentariosEstructura 
                      comm={comm} 
                      eliminarComment={eliminarComment}
                      editarComment={editarComment}
                      fijarComment={fijarComment}
                    />
                    // <div>
                    //   <img
                    //     src={Delete}
                    //     alt="ELIMINAR"
                    //     className="tableIcon"
                    //     onClick={() => eliminarComment(comm.id)}
                    //     style={{ width: 14, margin:0 }}
                    //   ></img>
                    //   <img
                    //     src={Editar}
                    //     alt={t('actions.edit')}
                    //     className="tableIcon"
                    //     onClick={() => editarComment(comm.id, comm)}
                    //     style={{ width: 14 }}
                    //   ></img>
                    //   {formatoFechasEs(comm.createdAt)} - {comm.usuario?.nombre + " " + comm.usuario?.apellidos} - {comm.texto}</div>
                  )
                })}
              </>
          }{" "}
        </div>
        {comentarios.length > 4 &&
          <div >
            <button onClick={() => setModalEditarOpened(true)} style={{ margin: '10px 0', borderRadius: '5px 5px', backgroundColor: '#92004D', color: '#ffffff', padding: '5px 10px' }}>{t('actions.showMore')}</button>
          </div>
        }
      </div>
      <div className="comment-input-container">
        <div className="comment-textarea-wrapper">
          <textarea id="comentarios" name="comentarios" value={comentario} label={t('form.comments')} onChange={cambiarComentarios} multiline rows={6} columns={100}
          />
          <div className="comment-submit-container">
            <button type="button" className="bigBtn" onClick={() => guardarComentarios()}>
              <IoSave style={{ fontSize: 20 }} /><span style={{ marginLeft: 5 }} />{t('comments.saveComments')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default withRouter(Comentarios);